<template>
	<div>
		<div class="topOptions flex_start">
			<el-select v-model="appSelectForm" :clearable="false" @change="appSeleteChange" size="small" value-key="value"
				popper-class="appNameIdOptions" :popper-append-to-body="false" filterable :remote-method="appRemoteMethod"
				:loading="appRemoteLoading" remote @clear="getMediaAppOption(2)" placeholder="请选择应用" style="width:280px">
				<el-option v-for="item in mediaAppOptions" :key="item.value" :value="item"
					:label="`应用：${item.label} | ${item.value}`">
					<!-- :label="`应用：${item.label} | ${item.value}`" -->
					<div class="selectTemp2">
						<div class="selectAppName">{{item.label}}</div>
						<div class=""></div>
						<div class="selectAppId flex_start">
							<div>{{item.value}}</div>
							<img @click.stop="copyName(item.value)" src="../../assets/icon/copy.png" alt="" />
						</div>
					</div>
				</el-option>
				<!-- <template #label="{ label, value }">
					<div class="checkedTemp2 flex_start" v-if="appSelectForm.value">
						<div class="checkedTips">应用：</div>
						<div class="checkedAppName">{{label}} | <span>{{value}}</span></div>
					</div>
				</template> -->
				<!-- <template #prefix>
					<div class="checkedTemp2 flex_start" v-if="appSelectForm.value">
						<div class="checkedTips">应用：</div>
					</div>
				</template> -->
			</el-select>
			<el-select v-model="adsSelectForm" :clearable="false" @change="adsSeleteChange" size="small" value-key="value"
				style="margin-left: 10px;width:280px" popper-class="appNameIdOptions" :popper-append-to-body="false" filterable
				:remote-method="adsRemoteMethod" :loading="adsRemoteLoading" remote placeholder="请选择广告位">
				<el-option v-for="item in mediaAdsOptions" :key="item.value" :label="`广告位：${item.label} | ${item.value}`"
					:value="item">
					<div class="selectTemp2">
						<div class="selectAppName">{{item.label}}</div>
						<div class=""></div>
						<div class="selectAppId flex_start">
							<div>{{item.value}}</div>
							<img @click.stop="copyName(item.value)" src="../../assets/icon/copy.png" alt="" />
						</div>
					</div>
				</el-option>
				<!-- <template #prefix>
				  <div class="checkedTemp flex_start" v-if="adConfigFormData.networkUrl">
				  	<img :src="adConfigFormData.networkUrl" alt="" />
				  </div>
				</template> -->
			</el-select>
			<el-button type="primary" @click="adConfigQuery" size="small" class="queryBtn">查询</el-button>
			<el-button @click="back" size="small" style="margin-left: auto;">退出</el-button>
		</div>
		<div class="networkList">
			<div class="networkTitRow space_between">
				<div class="networkTitle" @click="networkDrop" v-show="networkRowShow">已绑定的广告网络({{appNetworkList.length}}) <i class="el-icon-arrow-down"></i>
				</div>
				<div class="networkTitle" @click="networkDrop" v-show="!networkRowShow">已绑定的广告网络({{appNetworkList.length}}) <i class="el-icon-arrow-up"></i>
				</div>
				<div class="addNetworkBtn" @click="addChannel"><i class="el-icon-plus"></i>添加广告网络</div>
			</div>
			<div class="networkLabelList flex_start" v-show="networkRowShow && appNetworkList.length>0">
				<div class="networkLabel flex_start" v-for="(item,index) in appNetworkList" :key="index" @click="editChannel(item)">
					<img :src="item.icon" :style="{ opacity :item.status == 0 ? '0.5': '1'}" alt="" />
					<div :style="{ color :item.status == 0 ? '#999999': ''}">{{item.platformName}}</div>
				</div>
			</div>
		</div>
		<div class="headTabs">
			<el-tabs v-model="activeTab">
				<el-tab-pane label="默认分组" value="1" name="1"></el-tab-pane>
			</el-tabs>
		</div>
		<div class="groupBox">
			<div class="groupTitle">竞价分组</div>
			<div>
				<div class="addBtns flex_start">
					<el-button type="primary" @click="addTable(biddingForm,1)" size="small">添加竞价广告源</el-button>
					<div class="queryTime" v-show="biddingForm.adsPlatList.length>0&&!biddingForm.queryTimeIptShow">
						<span>请求时长(ms)</span>{{biddingForm.timeout}}
					</div>
					<div class="queryTimeInput flex_start" v-show="biddingForm.queryTimeIptShow == true">
						<span>请求时长(ms)</span>
						<el-input clearable size="small" style="width: 180px;" placeholder="请输入"
							@blur="confirmQueryTime(biddingForm,1,0)" v-model="biddingForm.timeout"></el-input>
					</div>
					<img class="editTimeIcon" v-show="biddingForm.adsPlatList.length>0" @click="editQueryTime(1)"
						src="../../assets/icon/editIcon.png" alt="" />
				</div>
				<el-table :max-height="560" :header-cell-style="{color:'#333333',background:'#EAEFF5'}"
					:data="biddingForm.adsPlatList" class="el_table">
					<el-table-column prop="" label="广告网络">
						<template slot-scope="scope">
							<div class="selectTemp flex_start">
								<img :src="scope.row.icon" alt="" />
								<div>{{scope.row.platformName}}</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="" label="广告源">
						<template slot-scope="scope">
							<div>
								<div>{{scope.row.platAdsName}}</div>
							</div>
							<div style="color: #999999;">{{scope.row.platAdsId}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="" label="状态">
						<template slot-scope="scope">
							<el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0"
								@change="adSwitchChange($event,scope.row)"></el-switch>
						</template>
					</el-table-column>
					<el-table-column prop="" label="价格">竞价</el-table-column>
					<el-table-column prop="divideRatio" label="分成"></el-table-column>
					<el-table-column prop="" label="操作" fixed="right" width="150">
						<template slot-scope="scope">
							<el-button type="text" @click="editTable(scope.row,scope.$index,1)">编辑</el-button>
							<el-button type="text" @click="deleteBuilding(scope.row,1)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="groupBox">
			<div class="groupTitle">固价分组</div>
			<div v-for="(item,index) in platAdsList" :key="index">
				<div class="addBtns flex_start">
					<el-button type="primary" @click="addTable(item,2)" size="small">添加固价广告源</el-button>
					<div class="queryTime" v-show="item.adsPlatList.length>0&&!item.queryTimeIptShow">
						<span>请求时长(ms)</span>{{item.timeout}}
					</div>
					<div class="queryTimeInput flex_start" v-show="item.queryTimeIptShow == true">
						<span>请求时长(ms)</span>
						<el-input clearable size="small" style="width: 180px;" placeholder="请输入"
							@blur="confirmQueryTime(item,2,index)" v-model="item.timeout"></el-input>
					</div>
					<img class="editTimeIcon" v-show="item.adsPlatList.length>0" @click="editQueryTime(2,index)"
						src="../../assets/icon/editIcon.png" alt="" />
					<div class="deleteBtn" @click="deleteBuilding(item,2)" v-show="item.adsPlatList.length>0">删除分组</div>
				</div>
				<el-table :max-height="560" :header-cell-style="{color:'#333333',background:'#EAEFF5'}" :data="item.adsPlatList"
					class="el_table">
					<el-table-column prop="" label="广告网络">
						<template slot-scope="scope">
							<div class="selectTemp flex_start">
								<img :src="scope.row.icon" alt="" />
								<div>{{scope.row.platformName}}</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="" label="广告源">
						<template slot-scope="scope">
							<div>
								<div>{{scope.row.platAdsName}}</div>
							</div>
							<div style="color: #999999;">{{scope.row.platAdsId}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="" label="状态">
						<template slot-scope="scope">
							<el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0"
								@change="adSwitchChange($event,scope.row)"></el-switch>
						</template>
					</el-table-column>
					<el-table-column prop="priceFloorDou" label="价格"></el-table-column>
					<el-table-column prop="divideRatio" label="分成"></el-table-column>
					<el-table-column prop="" label="操作" fixed="right" width="150">
						<template slot-scope="scope">
							<el-button type="text" @click="editTable(scope.row,scope.$index,2)">编辑</el-button>
							<el-button type="text" @click="deleteBuilding(scope.row,1)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="addBtns" @click="addAdGroup"><i class="el-icon-plus"></i> 添加固价分组</div>
		<el-dialog title="" :visible.sync="dialogVisible" width="36%">
			<div slot="title" class="dialog_title">
				<div>{{appSelectForm.label}}｜<span>{{appSelectForm.value}}</span> {{adsSelectForm.label}}</div>
			</div>
			<div class="dialogSubTitle">{{networkDialogTitle}}</div>
			<el-form inline class="el-form el_dialog_form" label-width="140px" :rules="rulesApi" :model="adConfigFormData"
				ref="ruleForm">
				<el-form-item label="广告网络：" prop="platformNetworkId" style="margin-bottom: 15px;">
					<el-select v-model="networkSelectForm" clearable @change="networkSeleteChange" size="small"
						value-key="platformNetworkId">
						<el-option v-for="item in networkOptions" :key="item.platformNetworkId" :label="item.platformName"
							:value="item">
							<div class="selectTemp flex_start">
								<img :src="item.icon" alt="" />
								<div>{{item.platformName}}</div>
							</div>
						</el-option>
						<template #prefix>
							<div class="checkedTemp flex_start" v-if="networkSelectForm.icon">
								<img :src="networkSelectForm.icon" alt="" />
							</div>
						</template>
					</el-select>
				</el-form-item>
				<el-form-item label="账号名称：" style="margin-bottom: 5px;" v-show="networkSelectForm.account">
					<div>
						{{networkSelectForm.account}}
					</div>
				</el-form-item>
				<el-form-item label="应用ID：" style="margin-bottom: 5px;" v-show="networkSelectForm.appKey">
					<div>{{networkSelectForm.appKey}}</div>
				</el-form-item>
				<el-form-item label="APP Key：" style="margin-bottom: 5px;" v-show="networkSelectForm.appSecret">
					<div>{{networkSelectForm.appSecret}}</div>
				</el-form-item>
				<el-form-item label="广告源名称：" prop="platAdsName">
					<el-input clearable size="small" placeholder="请输入" v-model="adConfigFormData.platAdsName"></el-input>
				</el-form-item>
				<el-form-item label="广告源ID：" prop="platAdsId">
					<el-input clearable size="small" placeholder="请输入" v-model="adConfigFormData.platAdsId"></el-input>
				</el-form-item>
				<template v-if="adsType == 'REWARD_VIDEO_AD'&&appFormData.serverCallback == 1">
					<el-form-item label="服务器回调：" prop="serverCallback">
						<el-switch v-model="adConfigFormData.serverCallback" :active-value="1" :inactive-value="0"></el-switch>
					</el-form-item>
					<el-form-item label="Secret：" prop="notifySecret" v-if="adConfigFormData.serverCallback == 1">
						<el-input clearable size="small" placeholder="请输入" v-model="adConfigFormData.notifySecret"></el-input>
					</el-form-item>
				</template>
				<el-form-item label="渲染类型：">
					<div v-if="adsInfoData.isSelfRender === 1">自渲染</div>
					<div v-if="adsInfoData.isSelfRender === 0">模板渲染</div>
				</el-form-item>
				<el-form-item label="竞价类型：">
					<div v-if="adConfigFormData.bidding == 2">应用内竞价</div>
					<div v-if="adConfigFormData.bidding == 1">固价</div>
				</el-form-item>
				<el-form-item label="价格：" prop="priceFloorDou" v-if="adConfigFormData.bidding == 1">
					<el-input clearable size="small" placeholder="请输入" v-model="adConfigFormData.priceFloorDou"></el-input>
				</el-form-item>
				<el-form-item label="分成比例：" prop="divideRatio">
					<el-input clearable size="small" type="number" :min="0" :max="1" step="0.01" placeholder="请输入0-1的分成比例"
						v-model.number="adConfigFormData.divideRatio" @input="handleDivideRatioInput"></el-input>
				</el-form-item>
				<el-form-item label="点击率上限(%)：" prop="clickRateLimit">
					<el-input clearable size="small" type="number" :min="0" :max="100" step="1" placeholder="请输入点击率上限(%) 0~100"
						v-model.number="adConfigFormData.clickRateLimit" @input="handleClickRateLimitInput"></el-input>
				</el-form-item>
				<el-form-item label="ecpm成本控制：">
					<el-input clearable size="small" placeholder="请输入" v-model="adConfigFormData.ecpmConfine">
						<i slot="suffix" style="font-style:normal;margin-right: 10px; line-height: 30px; color: #1e1e1e">分</i>
					</el-input>
				</el-form-item>
				<el-form-item prop="versionControl">
					<template slot="label">
						<el-tooltip effect="dark" content="低于输入的版本号不下发此条配置" placement="top">
							<img src="../../assets/icon/iconQuestion.png" alt="" style="width: 14px; height: 14px; vertical-align: middle; margin-left: 4px; cursor: help;" />
						</el-tooltip>
						版本限制：
					</template>
					<el-input clearable size="small" placeholder="请输入版本号，如 4.0.11" v-model="adConfigFormData.versionControl"></el-input>
				</el-form-item>
				<!-- oninput="if(value){value=value.replace(/[^\d]/g,1);
					if(Number(value)<=0){value=0}} if(Number(value)>1){value=1}" -->
				<div class="card-bottom flex_end">
					<el-button @click="closeDialog" size="medium">取消</el-button>
					<el-button type="primary" @click="confirmDialog('ruleForm')" size="medium">确定</el-button>
				</div>
			</el-form>
		</el-dialog>
		<el-dialog title="管理广告网络" :visible.sync="channelDialogVisible" width="28%">
			<el-form inline class="el-form el_dialog_form" label-width="120px" :rules="channelRulesApi"
				:model="channelFormData" ref="ruleChannelForm">
				<el-form-item label="广告网络：" prop="platformId">
					<el-select v-model="networkSelectForms" clearable @change="networkChannelSeleteChange" size="small"
						value-key="id">
						<el-option v-for="item in networkChannelOptions" :key="item.id" :label="item.label" :value="item">
							<div class="selectTemp flex_start">
								<img :src="item.icon" alt="" />
								<div>{{item.label}}</div>
							</div>
						</el-option>
						<template #prefix>
						  <div class="checkedTemp flex_start" v-if="networkSelectForms.icon">
						  	<img :src="networkSelectForms.icon" alt="" />
						  </div>
						</template>
					</el-select>
				</el-form-item>
				<el-form-item label="账号名称：" prop="platformNetworkId">
					<el-select v-model="channelFormData.platformNetworkId" clearable size="small">
						<el-option v-for="item in accountOptions" :key="item.value" :label="item.label" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="应用ID：" prop="appKey">
					<el-input clearable size="small" placeholder="请输入" v-model="channelFormData.appKey"></el-input>
				</el-form-item>
				<el-form-item label="APP KEY：" prop="appSecret" v-if="hasPlatformIdProps">
					<el-input clearable size="small" placeholder="请输入" v-model="channelFormData.appSecret"></el-input>
				</el-form-item>
				<el-form-item label="启用状态：" required>
					<el-switch v-model="channelFormData.status" :active-value="1" :inactive-value="0"></el-switch>
				</el-form-item>
				<div class="card-bottom flex_end">
					<el-button @click="closeChannelDialog" size="medium">取消</el-button>
					<el-button type="primary" @click="confirmChannel('ruleChannelForm')" size="medium">确定</el-button>
				</div>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeTab: '1',
				adsId: '',
				appId: '',
				adsType: '',

				networkRowShow: true,
				appNetworkList: [],

				appSelectForm: {},
				mediaAppOptions: [],
				appRemoteLoading: false,
				adsSelectForm: {},
				mediaAdsOptions: [],
				adsRemoteLoading: false,

				biddingForm: {
					groupId: null,
					timeout: 3000,
					adsPlatList: []
				},
				// 固价列表
				platAdsList: [],


				dialogVisible: false,
				networkOptions: [
					// {label: 'Sigmob',value: 'Sigmob',icon: require('../../assets/adsNetwork/Sigmob.png')}
				],
				rulesApi: {
					platformNetworkId: [{
						required: true,
						message: '请选择广告网络',
						trigger: 'blur'
					}],
					platAdsName: [{
						required: true,
						message: '请输入广告源名称',
						trigger: 'blur'
					}],
					platAdsId: [{
						required: true,
						message: '请输入广告源ID',
						trigger: 'blur'
					}],
					priceFloorDou: [{
						required: true,
						message: '请输入价格',
						trigger: 'blur'
					}],
					// 版本限制可留空，填写时只接受三段数字版本号。
					versionControl: [{
						pattern: /^(?:\d+\.\d+\.\d+)?$/,
						message: '请输入正确的版本号，如 4.0.11',
						trigger: 'blur'
					}],
				},
				adConfigFormData: {
					platAdsName: '',
					apiStatus: 0,
					divideRatio: 1,
					// 版本限制默认为空，作为可选的广告源配置参数提交。
					versionControl: ''
				},
				networkDialogTitle: '添加广告源',
				networkSelectForm: {},
				
				appFormData: {
					serverCallback: ''
				},
				adsInfoData: {},
				
				channelDialogVisible: false, //
				channelRulesApi: {
					platformId: [{required: true,message: '请选择广告网络',trigger: 'blur'}],
					platformNetworkId: [{required: true,message: '请选择账号名称',trigger: 'blur'}],
					appKey: [{required: true,message: '请输入应用ID',trigger: 'blur'}],
					appSecret:[{required: true,message: '请输入appSecret',trigger: 'blur'}]
				},
				channelFormData: {
					status: 1
				},
				networkSelectForms: {},
				accountOptions: [], // 账号下拉选择列表
				networkChannelOptions: [],
			}
		},
		activated() {
			if (this.$route.query.id) {
				this.adsId = this.$route.query.id
				this.appId = this.$route.query.appId
				this.adsType = this.$route.query.type
				this.getChannelNetworkOtions();
				this.getFormData();
				this.getAdInfoData(this.adsId);
				this.$nextTick(() => {
					this.getNetworkOtions();
				})
				this.getMediaAppOption(1);
			}
		},
		computed: {
			// 检查是否存在特定的prop
			hasPlatformIdProps() {
				const requiredProps = ['SIGMOB', 'FW','BLK', 'JUTUI', 'CXING'];
				return requiredProps.some(prop => this.networkSelectForms.platformId === prop )
			},
		},
		mounted() {
		},
		methods: {
			async getNetworkOtions() {
				let data = {
					appId: this.appId
				}
				let res = await this.$http.post(this.$api.mediaAd.adsConfigNetworkOptions, data);
				this.networkOptions = res.data
			},
			// 获取配置后的广告网络下拉选择列表
			async getChannelNetworkOtions(){
				let res = await this.$http.get(this.$api.mediaAd.networkOptionDistinct);
				this.networkChannelOptions = res.data
			},
			async getAdInfoData(id) {
				let data = {
					pageNum: 1,
					pageSize: 10,
					id: id
				}
				let res = await this.$http.post(this.$api.mediaAd.adsList, data);
				if(res.data.list&&res.data.list.length>0){
					this.adsInfoData = res.data.list[0]
				}
			},
			handleDivideRatioInput(value) {
				// 清理输入，只允许数字和小数点
				let cleanedValue = value.replace(/[^\d.]/g, '');

				// 确保只有一个小数点
				const parts = cleanedValue.split('.');
				if (parts.length > 2) {
					cleanedValue = parts[0] + '.' + parts.slice(1).join('');
				}
				// 确保小数点后最多两位
				if (parts.length > 1) {
					cleanedValue = parts[0] + '.' + parts[1].slice(0, 2);
				}
				// 转换为数字并确保范围
				if (cleanedValue !== '' && cleanedValue !== '.') {
					let numValue = parseFloat(cleanedValue);
					if (isNaN(numValue)) {
						numValue = 0;
					} else if (numValue < 0) {
						numValue = 0;
					} else if (numValue > 1) {
						numValue = 1;
					}

					this.adConfigFormData.divideRatio = numValue;
					this.divideRatioInput = cleanedValue;
				} else {
					this.adConfigFormData.divideRatio = null;
					// this.divideRatioInput = cleanedValue;
				}
			},
			handleClickRateLimitInput(value) {
				let cleanedValue = String(value).replace(/[^\d]/g, '');
				if (cleanedValue !== '') {
					let numValue = parseInt(cleanedValue, 10);
					if (isNaN(numValue)) {
						numValue = 0;
					} else if (numValue > 100) {
						numValue = 100;
					}
					this.adConfigFormData.clickRateLimit = numValue;
				} else {
					this.adConfigFormData.clickRateLimit = null;
				}
			},
			// 获取APP的网络数据
			async getAppNetworkData(appId) {
				let data = {
					pageNum: 1,
					pageSize: 10,
					id: appId
				}
				let res = await this.$http.post(this.$api.mediaManage.APPList, data);
				if (res.data.list && res.data.list.length > 0) {
					this.appFormData = res.data.list[0]
					if (res.data.list[0].platAppList) {
						this.appNetworkList = res.data.list[0].platAppList
					}
				}
			},
			adConfigQuery(){
				this.getFormData();
			},
			// 获取媒体APP下拉列表
			async getMediaAppOption(type, query = null) {
				let data = {
					appId: query
				}
				let res = await this.$http.get(this.$api.common.mediaAppOptionFilter, data);
				this.mediaAppOptions = res.data
				if (type == 1) {
					if (this.appId) {
						this.mediaAppOptions.forEach((item) => {
							if (item.value == this.appId) {
								this.appSelectForm = JSON.parse(JSON.stringify(item))
								this.getAppNetworkData(this.appId);
								this.getMediaAdsOption(1);
							}
						})
					}
				}
				this.appRemoteLoading = false
			},
			// 获取媒体广告位下拉列表
			async getMediaAdsOption(type, query = null, types = null) {
				if (!this.appSelectForm.value) {
					return
				}
				let data = {
					appId: this.appSelectForm.value,
					adsName: query
				}
				let res = await this.$http.get(this.$api.common.mediaAdsOption, data);
				this.adsRemoteLoading = false
				this.mediaAdsOptions = res.data
				if (type == 1) {
					if (this.adsId) {
						this.mediaAdsOptions.forEach((item) => {
							if (item.value == this.adsId) {
								this.adsSelectForm = JSON.parse(JSON.stringify(item))
							}
						})
					}
				}
				if(types == 1){
					if(this.mediaAdsOptions.length > 0){
						this.adsSelectForm = JSON.parse(JSON.stringify(this.mediaAdsOptions[0]));
					}
				}
			},
			// 复制APP名称
			async copyName(txt) {
				try {
					// 使用现代异步 API
					await navigator.clipboard.writeText(txt)
					this.$message.success('复制成功');
				} catch (err) {
					// 某些环境（比如 HTTP 或非安全上下文）不支持 navigator.clipboard
					// 这里可做回退方案：
					this.fallbackCopy(txt)
				}
			},
			fallbackCopy(text) {
				const input = document.createElement('input')
				input.value = text
				document.body.appendChild(input)
				input.select()
				document.execCommand('copy')
				document.body.removeChild(input)
				this.$message.success('复制成功');
			},
			networkDrop() {
				this.networkRowShow = !this.networkRowShow
			},
			appRemoteMethod(query) {
				clearTimeout();
				setTimeout(() => {
					this.appRemoteLoading = true
					this.getMediaAppOption(2, query)
				}, 300)
			},
			adsRemoteMethod(query) {
				clearTimeout();
				setTimeout(() => {
					this.adsRemoteLoading = true
					this.getMediaAdsOption(2, query)
				}, 300)
			},
			// 获取详情信息
			async getFormData() {
				let data = {
					pageNum: 1,
					pageSize: 10,
					id: this.adsId,
					appId: this.appId
				}
				let res = await this.$http.post(this.$api.mediaAd.adsConfigDetial, data);
				if (res.code == 1) {
					if (res.data.bidingPlatAdsList && res.data.bidingPlatAdsList.length > 0) {
						this.biddingForm = res.data.bidingPlatAdsList[0]
					} else {
						this.biddingForm = {
							groupId: null,
							timeout: 3000,
							adsPlatList: []
						}
					}
					if (res.data.platAdsList && res.data.platAdsList.length > 0) {
						this.platAdsList = res.data.platAdsList
					} else {
						this.platAdsList = []
					}
				}
			},
			appSeleteChange(e) {
				this.appSelectForm = e
				this.mediaAdsOptions = []
				if (e && e.value) {
					this.appId = this.appSelectForm.value
					this.adsSelectForm = {}
					this.platAdsList = []
					this.appNetworkList = []
					this.biddingForm = {
						groupId: null,
						timeout: 3000,
						adsPlatList: []
					}
					this.getAppNetworkData(this.appId);
					this.getMediaAdsOption(2,null,1);
				}
			},
			adsSeleteChange(e) {
				this.adsSelectForm = e
				if (e && e.value) {
					this.adsId = this.adsSelectForm.value
					this.getFormData();
					this.getAdInfoData(this.adsId);
				}
			},
			editQueryTime(type, index = 0) {
				if (type == 1) {
					this.$set(this.biddingForm, 'queryTimeIptShow', true);
					// this.biddingForm['queryTimeIptShow'] = true
				} else {
					// this.platAdsList[index]['queryTimeIptShow'] = true
					this.$set(this.platAdsList, index, {
						...this.platAdsList[index],
						queryTimeIptShow: true
					})
				}
			},
			async confirmQueryTime(item, type, index) {
				let data = {
					groupId: item.groupId,
					timeout: item.timeout
				}
				let res = await this.$http.post(this.$api.mediaAd.adsConfigQueryTime, data);
				if (res.code == 1) {
					this.$message.success('修改成功')
					this.getFormData(); // 刷新
				}
			},
			deleteBuilding(row, type) {
				let msg = '此操作将删除该组配置信息, 是否继续?'
				if (type == 1) {
					let msg = '此操作将删除该条配置信息, 是否继续?'
				}
				this.$confirm('此操作将删除该条配置信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let id = row.groupId
					if (type == 1) {
						id = row.id
					}
					let data = {
						id: id,
						type: type
					}
					let res = await this.$http.post(this.$api.mediaAd.adsConfigDelete, data);
					if (res.code == 1) {
						this.$message.success('删除成功')
						this.getFormData(); // 刷新
					}
				}).catch();
			},
			// 广告位配置删除分组
			// deleteAdGroup(row, index) {
			// 	this.platAdsList.splice(index, 1)
			// },
			// 广告位配置新增分组
			addAdGroup() {
				let obj = {
					groupId: null,
					timeout: 3000,
					adsPlatList: [],
				}
				this.platAdsList.push(obj)
			},
			addTable(item, type) {
				if(!this.adsSelectForm.value){
					this.$message.warning('请先添加广告位');
					return
				}
				this.networkDialogTitle = '添加广告源'
				this.adConfigFormData = {
					platAdsName: '',
					apiStatus: 0,
					divideRatio: 1,
					// 新增广告源时不限制版本。
					versionControl: '',
					timeout: item.timeout,
					groupId: item.groupId,
				}
				this.networkSelectForm = {}
				if (type == 1) {
					this.adConfigFormData['bidding'] = 2
				} else {
					this.adConfigFormData['bidding'] = 1
				}
				this.dialogVisible = true
			},
			editTable(row, index, type) {
				this.networkDialogTitle = '编辑广告源'
				this.adConfigFormData = JSON.parse(JSON.stringify(row))
				// 旧广告源可能没有版本限制字段，回填为空值以便编辑和提交。
				this.$set(this.adConfigFormData, 'versionControl', this.adConfigFormData.versionControl || '')
				if (this.adConfigFormData.clickRateLimit !== null && this.adConfigFormData.clickRateLimit !== undefined && this.adConfigFormData.clickRateLimit !== '') {
					this.adConfigFormData.clickRateLimit = Math.round(this.adConfigFormData.clickRateLimit * 100)
				}
				this.networkOptions.forEach((item) => {
					if (item.platformNetworkId === this.adConfigFormData.platformNetworkId) {
						this.networkSelectForm = JSON.parse(JSON.stringify(item))
					}
				})
				this.dialogVisible = true
			},
			networkSeleteChange(e) {
				// console.log(e);
				this.adConfigFormData.platformNetworkId = e.platformNetworkId
				this.networkSelectForm = e
				if(e.platformNetworkId && this.networkDialogTitle == '添加广告源'){
					let timeDate = this.getFormattedDateTime();
					this.adConfigFormData['platAdsName'] = e.platformName + '_' + this.adsInfoData.typeValue + '_' + timeDate
				}
				// console.log(this.networkSelectForm)
			},
			// 获取格式化时间
			getFormattedDateTime() {
			  const now = new Date();
			  // 获取年份后两位
			  // const year = now.getFullYear().toString().slice(-2);
			  // 获取月份（0-11，需要+1）
			  const month = String(now.getMonth() + 1).padStart(2, '0');
			  // 获取日期
			  const day = String(now.getDate()).padStart(2, '0');
			  // 获取小时
			  const hours = String(now.getHours()).padStart(2, '0');
			  // 获取分钟
			  const minutes = String(now.getMinutes()).padStart(2, '0');
			  // 获取秒数
			  const seconds = String(now.getSeconds()).padStart(2, '0');
			  // 用下划线拼接
			  return `${month}_${day}_${hours}:${minutes}:${seconds}`;
			},
			closeDialog() {
				this.dialogVisible = false
			},
			confirmDialog(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						let platAdsInfo = JSON.parse(JSON.stringify(this.adConfigFormData))
						if (platAdsInfo.clickRateLimit !== null && platAdsInfo.clickRateLimit !== undefined && platAdsInfo.clickRateLimit !== '') {
							platAdsInfo.clickRateLimit = platAdsInfo.clickRateLimit / 100
						}
						let data = {
							adsId: this.adsId,
							appId: this.appId,
							platAdsInfo: platAdsInfo
						};
						let res = await this.$http.post(this.$api.mediaAd.adsConfigSave, data);
						if (res.code == 1) {
							this.$message.success('保存成功');
							this.closeDialog();
						}
						this.getFormData();
					}
				});
			},
			// 广告位配置状态修改
			async adSwitchChange(e, row) {
				let platAdsInfo = JSON.parse(JSON.stringify(row))
				platAdsInfo['status'] = e
				let data = {
					adsId: this.adsId,
					appId: this.appId,
					platAdsInfo: platAdsInfo
				};
				let res = await this.$http.post(this.$api.mediaAd.adsConfigSave, data);
				if (res.code == 1) {
					this.$message.success('状态修改成功');
				}
				this.getFormData();
			},
			
			
			addChannel() {
				this.channelFormData = {
					status: 1,
					platformNetworkId: ''
				}
				this.$set(this, 'networkSelectForms', {})
				this.channelDialogVisible = true
			},
			editChannel(row) {
				this.channelFormData = row
				// console.log(this.networkOptions)
				// console.log(this.channelFormData.platformNetworkId)
				this.networkChannelOptions.forEach((item)=>{
					if(item.platformId == this.channelFormData.platformId){
						this.networkSelectForms = JSON.parse(JSON.stringify(item))
						this.getAccountOptions(item.platformId);
					}
				})
				this.channelDialogVisible = true
			},
			networkChannelSeleteChange(e){
				this.accountOptions = []
				this.channelFormData.platformNetworkId = ''
				if(e){
					this.channelFormData.platformId = e.platformId
					this.networkSelectForms = e
					this.getAccountOptions(e.platformId);
				}
			},
			closeChannelDialog() {
				this.channelDialogVisible = false
			},
			// 渠道新增编辑框确认
			confirmChannel(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						let data = this.channelFormData;
						data['appId'] = this.appFormData.id
						data['appName'] = this.appFormData.name
						// console.log(JSON.stringify(data))
						if (data.id) {
							let res = await this.$http.post(this.$api.mediaManage.platformAppEdit, data);
							if (res.code == 1) {
								this.$message.success('修改成功');
								this.closeChannelDialog();
							}
						} else {
							let res = await this.$http.post(this.$api.mediaManage.platformAppAdd, data);
							if (res.code == 1) {
								this.$message.success('新增成功');
								this.closeChannelDialog();
							}
						}
						this.getAppNetworkData(this.appFormData.id);
					}
				});
			},
			async getAccountOptions(platformId){
				let data = {platformId: platformId}
				let res = await this.$http.get(this.$api.mediaAd.networkAccountOption,data);
				this.accountOptions = res.data
			},
			back(){
				this.$router.go(-1);
			}
		}
	}
</script>

<style scoped>
	.queryBtn{
		height: 32px;
		margin-left: 10px;
		padding: 0 15px;
	}
	.topOptions {
		background: #FFFFFF;
		margin: 10px;
		padding: 0 16px;
		height: 64px;
		align-items: center;
		box-sizing: border-box;
		border-radius: 4px;
	}

	/* 平板及手机端配置查询区允许换行，避免应用和广告位筛选被截断 */
	@media screen and (max-width: 1024px) {
		.topOptions {
			align-items: center;
			flex-wrap: wrap;
			gap: 10px;
			height: auto;
			padding-bottom: 12px;
			padding-top: 12px;
		}
	}

	/* 手机端两个选择器各占一行，为查询按钮保留完整展示空间 */
	@media screen and (max-width: 768px) {
		.topOptions>.el-select {
			margin-left: 0 !important;
			width: 100% !important;
		}

		.queryBtn {
			margin-left: 0;
		}
	}

	.networkList {
		background: #FFFFFF;
		margin: 10px;
		border-radius: 4px;
		padding: 14px 18px;
		padding-bottom: 8px;
	}

	.networkTitRow{
		align-items: center;
	}
	.networkTitle {
		font-weight: 600;
		font-size: 14px;
		color: #333333;
		line-height: 20px;
		cursor: pointer;
	}
	.addNetworkBtn{
		font-weight: 600;
		font-size: 14px;
		color: #007FFF;
		cursor: pointer;
	}
	.addNetworkBtn i{
		font-weight: 600;
		/* font-size: 16px; */
		margin-right: 3px;
	}

	.networkLabelList {
		margin-top: 12px;
		flex-wrap: wrap;
	}

	.networkLabel {
		margin-right: 10px;
		margin-bottom: 10px;
		align-items: center;
		height: 32px;
		padding: 0 10px;
		border: 1px solid #E0E0E5;
		box-sizing: border-box;
		border-radius: 4px;
		cursor: pointer;
	}

	.networkLabel img {
		width: 24px;
		height: 24px;
	}

	.networkLabel div {
		font-size: 14px;
		color: #333333;
		margin-left: 4px;
	}

	.headTabs {
		background: #FFFFFF;
		padding: 0 20px;
		margin: 10px;
		font-size: 16px;
	}

	/deep/ .el-tabs__header {
		margin-bottom: 0;
	}

	/* 使用 /deep/ 选择器覆盖 Element UI 的默认样式 */
	/deep/ .el-tabs__nav-wrap::after {
		height: 0;
		/* 移除底部的边框线 */
	}

	/deep/ .el-tabs__item {
		height: 48px;
		line-height: 48px;
		color: #999999;
	}

	/deep/ .el-tabs__item.is-active {
		color: #007FFF;
	}

	.groupBox {
		background: #FFFFFF;
		margin: 10px;
		padding: 16px;
		padding-top: 20px;
		box-sizing: border-box;
		border-radius: 4px;
	}

	.groupTitle {
		font-weight: 600;
		font-size: 16px;
		color: #333333;
	}

	.addBtns {
		align-items: center;
		margin-top: 16px;
	}

	.queryTime,
	.queryTimeInput {
		font-weight: 600;
		font-size: 16px;
		color: #333333;
		margin-left: 32px;
		margin-right: 4px;
	}

	.queryTime span,
	.queryTimeInput span {
		font-weight: 500;
		font-size: 14px;
		color: #666666;
		margin-right: 8px;
	}

	.queryTimeInput {
		align-items: center;
	}

	.editTimeIcon {
		width: 16px;
		height: 16px;
		cursor: pointer;
	}

	.deleteBtn {
		font-weight: 600;
		font-size: 14px;
		color: #FF4D4F;
		margin-left: auto;
		cursor: pointer;
	}


	.el_table {
		margin-top: 12px;
		color: #333333;
	}

	.selectTemp,
	.checkedTemp {
		align-items: center;
		width: 100%;
		font-weight: 500;
		font-size: 14px;
		color: #333333;
	}

	.selectTemp img,
	.checkedTemp img {
		width: 24px;
		height: 24px;
		margin-right: 4px;
	}

	.checkedTemp {
		height: 32px;
		margin-top: 4px;
	}

	.addBtns {
		font-weight: 600;
		font-size: 14px;
		color: #007FFF;
		margin: 16px 0;
		text-align: center;
		cursor: pointer;
	}


	/deep/ .el-dialog__body {
		padding-top: 16px;
	}

	.dialog_title {
		font-weight: 500;
		font-size: 14px;
		color: #333333;
	}

	.dialog_title span {
		color: #999999;
	}

	.dialogSubTitle {
		margin-bottom: 22px;
		font-weight: 600;
		font-size: 18px;
		color: #333333;
	}


	/deep/.appNameIdOptions .el-select-dropdown__item {
		height: 48px !important;
		line-height: 48px !important;
	}

	.selectTemp2 {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.selectAppName,
	.selectAppId {
		font-size: 12px;
		color: #333333;
		line-height: 20px;
	}

	.selectAppId {
		color: #999999;
		align-items: center;
	}

	.selectAppId img {
		width: 14px;
		height: 14px;
		margin-left: 3px;
	}

	.checkedTemp2 {
		height: 32px;
		line-height: 32px;
		padding-left: 0px;
	}

	.checkedTips {
		font-weight: 600;
		font-size: 12px;
		color: #333333;
	}

	.checkedAppName {
		font-size: 12px;
		color: #333333;
	}

	.checkedAppName span {
		color: #999999;
	}
</style>
